import React from 'react';
import {Container, Typography, Grid2} from '@mui/material';
import ScrollDownArrow from "./ScrollDownArrow";

function HeroContent() {
    return (
        <Container sx={{ padding: '128px 0 64px',  overflow: 'hidden'}}>
            <Grid2 container spacing={2} sx={{ display: 'flex', justifyContent: "center", flexDirection: { xs: 'column-reverse', sm: 'row'} }}>
                <Grid2
                    item
                    size={{ xs: 12, md: 8 }}
                    sx={{ display: 'flex', alignItems: "start", justifyContent: 'start', flexDirection: "column"}}
                >
                    <Typography variant="h1" component={'h1'} fontWeight={'bold'} fontSize={64} paddingTop={{ xs: '24px', sm: '0px'}}>
                        Hello~, I'm Tatiana.
                    </Typography>
                    <Typography variant="h3" fontWeight={'100'} sx={{marginTop: '32px'}}>
                        I'm passionate about <strong>UX/UI</strong> design. I love to realize the digital product that solves user experience problems.
                    </Typography>
                </Grid2>
                <Grid2 item  size={{ xs: 4, md: 2 }}>
                    <embed src={"/assets/images/TV(aboutme).png"} className={"mainLogo"} width={'170px'}/>
                </Grid2>
            </Grid2>

            <ScrollDownArrow />
        </Container>
    );
}

export default HeroContent;